import { Box, type BoxProps } from "@hightouch/htui";

export function QuickPromptsGrid(props: BoxProps): JSX.Element {
  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(auto-fit, minmax(min(100%, var(--chakra-sizes-28)), 1fr))"
      gridAutoRows="1fr"
      gap={5}
      width="100%"
      {...props}
    />
  );
}
